<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import i18n from '@/plugins/i18n'
import platformConfig from './config/PlatformConfig'

const title = ref(platformConfig.title)

onMounted(() => {
  document.title = `${i18n.global.t(title.value)} ${i18n.global.t('backstage')}`
})

// export default {
//   name: 'App',
//   components: {
//     HelloWorld
//   }
// }
</script>

<style lang="scss">
@use '@/assets/scss/config' as *;
@use '@/assets/scss/main' as *;
</style>
